import { render } from "./AppointmentPaymentFields.vue?vue&type=template&id=785a2bd3&scoped=true"
import script from "./AppointmentPaymentFields.vue?vue&type=script&lang=js"
export * from "./AppointmentPaymentFields.vue?vue&type=script&lang=js"

import "./AppointmentPaymentFields.vue?vue&type=style&index=0&id=785a2bd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785a2bd3"]])

export default __exports__